import { initApp } from '@adornis/functional-lit/init-app.js';
import { appRoot } from '@ndi/sdr-ui/app-root.js';
import { appSession } from '@ndi/sdr-ui/auth/app-session.js';
import { forgetSocketKey } from '@ndi/sdr-ui/auth/session.js';
import { sessionGuard, startSignInTitle } from '@ndi/sdr-ui/auth/session-guard.js';
import { startPageChange } from '@ndi/sdr-ui/router/page-change.js';
import { ROUTES } from '@ndi/sdr-ui/router/routes.js';
import { sdrFrame, sdrOutlet, sdrRouter } from '@ndi/sdr-ui/sdr-router.js';
import { initThemeChoice } from '@ndi/sdr-ui/theme-choice.js';
import './tailwind.css' with { type: 'tailwind' };

// The page signs in over REST since R13 (@ndi/sdr-ui/auth/session.ts): it opens no BaseQL
// socket and loads none of its models. The socket's script wrote the session cookie itself;
// beside the HttpOnly cookie the sign-in sets now, that would be two sessions in one browser
// (packages/sdr-ui/tests/client-session.test.ts). A browser that used the page before keeps the
// socket's copy of the session key in localStorage, readable by any script: it goes first.
forgetSocketKey();

// The theme chosen in the nav's footer, on <html> before anything renders (WP35); the frame shows
// the choice it applied, also when storage is blocked (R12d).
sdrFrame.theme.value = initThemeChoice();

// Title, <html lang>, scroll and focus on every page change (R12c), then the tab title over the
// sign-in (R13, after page change so it writes last), then the router reads the address. Its
// state never throws: an unknown path is the dashboard, at / (B1).
startPageChange(sdrRouter, ROUTES);
startSignInTitle({ session: appSession, router: sdrRouter, routes: ROUTES });
sdrRouter.start();

// A session that ends while the app is open: a 401 from /api/* and the tab coming back ask
// /api/auth/me again (decision 7.16). The first question is the guard's, on a page that needs it.
appSession.watch();

// Which routes are public is decided in one place, with a reason recorded per route
// (`@ndi/sdr-ui/public-routes.js`), and applied in appRoot; behind it, the session guard.
void initApp(() =>
  appRoot({ state: sdrRouter.state.value, outlet: sdrOutlet, guard: outlet => sessionGuard(appSession, outlet) }),
);
